// extracted by mini-css-extract-plugin
export default {"app":"_0aYKV0G1--app_app__wMRCB","wiggle":"_0aYKV0G1--app_wiggle__9zXZF","shimmer":"_0aYKV0G1--app_shimmer__AgxGF"};